module.exports = __webpack_public_path__ + "static/bg-158fa1d62551baf7fdc85a9e228f88ac.jpg";